export default {
  language: 'English',
  swap: 'Swap',
  buyToken: 'Buy Crypto',
  security: 'Token Security',
  placeholder: 'Search by Transaction Hash',
  transDetails: 'Transaction Details',
  status: 'Status:',
  statusSuccess: 'Success',
  statusFailure: 'Failed',
  onGoing: 'Ongoing',
  date: 'Date:',
  sourceChain: 'Source Chain:',
  chain: 'Chain:',
  destChain: 'Dest Chain:',
  sourceHash: 'Source Hash:',
  hash: 'Hash:',
  destHash: 'Dest Hash:',
  fromAddress: 'From Address:',
  toAddress: 'To Address:',
  sendValue: 'Send Value:',
  receiveValue: 'Receive Value:',
  liquidityProvider: 'Liquidity Provider:',
  errorMsg:
    'There is no result, please confirm whether the hash you entered is correct',

  secs: 'secs',
  min: 'min',
  mins: 'mins',
  hr: 'hr',
  hrs: 'hrs',
  day: 'day',
  days: 'days',
  ago: 'ago',

  lightTheme: 'Light Theme',
  darkTheme: 'Dark Theme',
  copied: 'Copied',
  copyHash: 'Copy Hash to clipboard',
  copySourceHash: 'Copy Source Hash to clipboard',
  copyDestHash: 'Copy Dest Hash to clipboard',
  copySourceAddress: 'Copy From Address to clipboard',
  copyDestAddress: 'Copy To Address to clipboard',
  securityText: 'Check Token Security Information',

  wait_deposit_send: 'waiting for token depositing',
  wait_exchange_push: 'Swap just started',
  wait_exchange_return: 'Swap waiting for return',
  wait_exchange_return_success: 'Swapping',
  wait_exchange_return_error: 'Swap returns error',
  wait_receive_send: 'Swap finished, waiting for sending',
  wait_receive_confirm: 'Sending tokens',
  wait_receive_confirm_error: 'Sending tokens error',
  wait_refund_send: 'Waiting for refund',
  wait_refund_confirm: 'Confirming refund',
  wait_refund_confirm_error: 'Refund error',
  refund_complete: 'Refund finished',
  Confirming: 'Swap finished, waiting for send token',
  Swapping: 'Sending tokens',
  BigAmount: 'Big amount, need confirmation',
  wait_deposit_send_error: 'Deposit error',
  timeout: 'Swap timeout',
  ERROR: 'Swap error',
  error_hacker: 'Swap failed',
  ExceedLimit: 'Less than limit',
  Failure: 'Failed',
  question: 'Have a question? Contact us.',
  desc1: "Transit Staffs won't send you private messages!",
  desc2:
    "Caution! You're entering Transit community, there might be someone impersonating us to send you private messages! Please be aware that, anyone who sends private messages might be a scammer! We will never contact you first!",
  desc3: 'Understood, enter',

  receive: 'Claim',
  received: 'Claimed',
  connectWallet: 'Connect Wallet',
  claimSuccessful: 'Claim successful',
  claimFailed: 'Claim Failed',
}
